import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

//styles
import './style.scss';

import useDeviceDetect from 'utils/useDeviceDetect';

//antd component
import { Button, Modal } from 'antd';

//assets
import {
  ArrowLeftOutlined,
  CloseOutlined,
  MoreOutlined,
} from '@ant-design/icons';
import CustomIcons from 'components/CustomIcons';

// context
import {
  useActiveChildSicknessAbs,
  useActiveChildAbsences,
} from 'engine/Contexts/User.context';
import { useCookies } from 'react-cookie';
import { isDateBeforeToday } from 'utils/moment/moment.utils';
import _local from 'utils/localStorageUtils';

function NotificationForParents({
  visibility,
  child,
  okHandle,
  cancelHandle,
  closeHandle,
  content,
  isNotification,
  children,
  className,
}) {
  const childClassName = classNames('notification-parents', className);
  const { t } = useTranslation();
  const { isMobile } = useDeviceDetect();

  const activeChild =  _local.getLocalChild();
  const activeChildAbsences = useActiveChildAbsences()();
  const activeSicknessAbs = useActiveChildSicknessAbs()();

  const childData = child ? child : activeChild;

  const [cookies, setCookie, removeCookie] = useCookies([
    'NotificationForParents',
  ]);

  const todayStart = new Date(new Date().setHours(0, 0, 0, 0));
  const tomorrowStart = new Date(
    new Date(new Date().setHours(0, 0, 0, 0)).setDate(new Date().getDate() + 1),
  );
  // const todayDate = today.toLocaleDateString();
  // const tomorrowDate = today.toLocaleDateString();
  const cookiesInitOption = {
    path: '/',
    expires: tomorrowStart, // + 1 day in ms
  };

  const checkCookiesNotif = () => {
    const arrNotif = cookies?.NotificationForParents?.notifications || [];
    const abs = activeChildAbsences
      ? activeChildAbsences?.find(abs => abs?._id == activeSicknessAbs?._id)
      : {};
    const absChild = abs?.student?._id || abs?.student;
    const newNotif = {
      child: absChild,
      sicknessAbs: activeSicknessAbs?._id,
      expires: tomorrowStart,
    };

    if (arrNotif && arrNotif?.length > 0) {
      const hasAbs = arrNotif.find(
        notif =>
          notif?.child == absChild &&
          notif?.sicknessAbs == activeSicknessAbs?._id,
      );
      if (
        (hasAbs && isDateBeforeToday(hasAbs?.expires)) &&
        newNotif?.sicknessAbs &&
        newNotif?.child
      ) {
        const newNotifArr =
          arrNotif.filter(notif => notif?.child == absChild && notif?.sicknessAbs != activeSicknessAbs?._id) || [];
        newNotifArr.push(newNotif);
        setCookie(
          'NotificationForParents',
          { notifications: newNotifArr },
          cookiesInitOption,
        );
      } else if (!hasAbs) {
        const newNotifArr =
          arrNotif.filter(notif => notif?.sicknessAbs != activeSicknessAbs?._id) || [];
        newNotifArr.push(newNotif);
        setCookie(
          'NotificationForParents',
          { notifications: newNotifArr },
          cookiesInitOption,
        );
      }
    } else {
      if (newNotif?.sicknessAbs && newNotif?.child) {
        arrNotif.push(newNotif);
        setCookie(
          'NotificationForParents',
          { notifications: arrNotif },
          cookiesInitOption,
        );
      }
    }
  };

  const canOpen = () => {
    if (isNotification) {
      const arrNotif = cookies?.NotificationForParents?.notifications || [];
      const abs = activeChildAbsences
        ? activeChildAbsences?.find(
            abs => abs?._id == activeSicknessAbs?._id,
          )
        : {};
      const absChild = abs?.student?._id || abs?.student;
      const newNotif = {
        child: absChild,
        sicknessAbs: activeSicknessAbs?._id,
        expires: tomorrowStart,
      };

      if (arrNotif && arrNotif?.length > 0) {
        const hasAbs = arrNotif.find(
          notif =>
            notif?.child == absChild &&
            notif?.sicknessAbs == activeSicknessAbs?._id,
        );
        if (
          (!hasAbs || (hasAbs && isDateBeforeToday(hasAbs?.expires))) &&
          newNotif?.sicknessAbs &&
          newNotif?.child
        ) {
          return true;
        } else if (hasAbs && !isDateBeforeToday(hasAbs?.expires)) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  };

  const okHandleCallback = () => {
    !!okHandle && okHandle();
    isNotification && checkCookiesNotif();
  };

  const cancelHandleCallback = () => {
    cancelHandle();
    isNotification && checkCookiesNotif();
  };

  const closeHandleCallback = () => {
    closeHandle();
  };

  const studentName = useCallback((stdObj, crop) => {
    const stdNameStr = stdObj?.description
    ? `${stdObj?.description?.lastname} ${
        crop && stdObj?.description?.firstname
          ? stdObj?.description?.firstname.substring(0, 1) + '.'
          : stdObj?.description?.firstname
      }`
    : '';
    return stdNameStr ? (
      <span className="student-name-title">{stdNameStr}</span>
    ) : (
      ''
    );
  }, []);

  return (
    <Modal
      className={childClassName}
      title={
        <>
          {isMobile && (
            <MoreOutlined className="notification-parents__mobile-menu" />
          )}
          <span className="modal-title">
            {`${t("absences.absenceRequest")}${childData?.description ? `: ` : ''}`}
            {childData?.description && studentName(childData)}
          </span>
        </>
      }
      open={canOpen() ? visibility : false}
      closeIcon={
        <span
          className="notification-parents__close"
          onClick={!!closeHandle && closeHandleCallback}
        >
          {!isMobile ? (
            <>
              <CloseOutlined /> {t("common.close")}
            </>
          ) : (
            <ArrowLeftOutlined />
          )}
        </span>
      }
      onCancel={!!closeHandle && closeHandle}
      footer={[]}
    >
      <div className="notification-parents-wrapper">
        <CustomIcons className="notification-parents__icon" type="virus" />
        {(content || children) && (
          <div
            className="notification-parents__content"
            dangerouslySetInnerHTML={{
              __html: !!(content || children) && (content || children) || t("notifications.notificationForParentContent")
            }}
          />
        )}
        <div className="notification-parents__actions">
          {/* Yes, the child is still sick */}
          {cancelHandle !== undefined && (
            <Button onClick={cancelHandleCallback} className="btn-sick">
              {t("absences.yesChildSick")}
            </Button>
          )}
          {/* No, the child is not sick anymore */}
          {okHandle !== undefined && (
            <Button onClick={okHandleCallback} className="btn-recovery">
              {t("absences.childNotSick")}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
}

NotificationForParents.defaultProps = {
  isNotification: false,
};
NotificationForParents.propTypes = {
  content: PropTypes.string,
  okHandle: PropTypes.func,
  cancelHandle: PropTypes.func,
  closeHandle: PropTypes.func,
};

export default memo(NotificationForParents);
